'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoFireball = function IoFireball(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.7 18.6c1.1 1.9 1.8 4.1 1.8 6.4 0 2.6-0.8 4.9-2 6.9-2.3 3.3-6.1 5.6-10.5 5.6-1.3 0-2.5-0.1-3.6-0.5s-1.9-1.1-2.6-2c-0.8-1.2-1.3-2.2-1.6-4.1-0.5 2 0.1 3.8 0.7 4.7-3.4-2-5.4-5.5-5.4-9.7v-0.4c0.4-6 5.1-8.5 7-11.8 0.7-1 1-2.3 0.8-3.7 0.9 0.7 1.2 2 1.2 3 0 1.3-0.3 2.3-0.3 2.3 0.4-0.6 0.6-1.4 0.8-2.4 0.4-2.7 0.1-6.7-2.9-10.3l-0.1-0.1s0.5 0 1.4 0.2c7.4 1.3 13.2 7.1 14.4 14.6 0.1 0.9 0.2 1.8 0.2 2.7 0 1.2-0.2 2.5-0.4 3.7 0.8-1.8 1-3.4 1.1-4.3v-0.8z' })
        )
    );
};

exports.default = IoFireball;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/fireball.js
// module id = 2507
// module chunks = 168707334958949